export default __webpack_public_path__ + "static/media/past-shipping.a1ebfb14.png";